<template>
    <Transition>
        <div class="alert-black-bg" v-if="isAlertOpen">
            <!-- 알림(notice) -->
            <div class="card alert-white-bg" v-if="alertStatus == 'notice'">
                <div class="card-body">
                    <h5 class="card-title"><i class="fas fa-exclamation-circle text-onmaum"></i> 알림</h5>
                    <p class="card-text">{{ `[${alertTitle}]` }}</p>
                    <p class="card-text" v-for="(content, i) in alertContent" :key="i">{{content}}</p>
                    <button class="btn btn-gradient-onmaum w-100 focusNotice" @click="this.$store.commit('toggleAlert');">확인</button>
                </div>
            </div>

            <!-- 확인(confirm) -->
            <div class="card alert-white-bg" v-if="alertStatus == 'confirm'">
                <div class="card-body">
                    <h5 class="card-title"><i class="ni ni-check-bold text-success"></i> 확인</h5>
                    <p class="card-text">{{ `[${alertTitle}]` }}</p>
                    <p class="card-text" v-for="(content, i) in alertContent" :key="i">{{content}}</p>
                    <div class="w-100 text-center">
                        <button class="btn btn-success w-40 me-1" @click="this.$store.dispatch(confirmCallback, confirmParameter);">네</button>
                        <button class="btn btn-outline-secondary w-40" @click="this.$store.commit('toggleAlert');">아니요</button>
                    </div>
                </div>
            </div>

            <!-- 오류(error) -->
            <div class="card alert-white-bg" v-if="alertStatus == 'error'">
                <div class="card-body">
                    <h5 class="card-title"><i class="fas fa-exclamation-triangle text-danger"></i> 오류</h5>
                    <p class="card-text">{{ `[${alertTitle}]` }}</p>
                    <p class="card-text" v-for="(content, i) in alertContent" :key="i">{{content}}</p>
                    <button class="btn btn-danger w-100 focusError" @click="this.$store.commit('toggleAlert');">확인</button>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script>
import $ from 'jquery'

export default {
    name: 'alertModal',
    data(){
        return {
           
        }
    },
    props:{
        isAlertOpen: Boolean,
        alertStatus: String,
        alertTitle: String,
        alertContent: String,
        confirmCallback: String,
        confirmParameter: Object,
    },
    methods:{
        
    },
    updated(){
        switch(this.alertStatus){
            case 'error':
                $('.focusError').focus();
                break;
            case 'notice':
                $('.focusNotice').focus();
                break;
        }
    }
}
</script>

<style>
.alert-black-bg {
  width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  padding: 20px;
  z-index: 9999;

  justify-content: center;
  align-items: center;
  display: flex;
}

.alert-white-bg {
  background: white;
  width: 20%;
  height: auto;
  position: relative;
  margin: auto;
  padding: 10px;
  border-radius: 8px;
}

.v-enter,
.v-leave-to {
    opacity: 0;
}

.v-enter-active,
.v-leave-active {
    transition: all 0.2s ease;
}
</style>